import type { IScaffold, IRunPlan } from '../types';

import { RegionScaffold } from '../scaffold/region';
import { HTMLFrameScaffold } from '../scaffold/iframe';

/**
 * create a scaffold from `scaffold.type`
 */
export class ScaffoldFactory {
  /**
   * hold all builders to write frame
   */
  readonly scaffolds = {
    region: new RegionScaffold(),
    iframe: new HTMLFrameScaffold()
  };

  /**
   * create a scaffold
   *
   * @param frameOptions
   * @returns
   */
  async create(runPlan: IRunPlan): Promise<IScaffold> {
    return this.scaffolds[runPlan.scaffold.type] ?? this.scaffolds.iframe;
  }
}
